export default function LongArrowDownGradientIcon(): JSX.Element {
  return (
    <svg
      width="16"
      height="35"
      viewBox="0 0 16 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1C9 0.447715 8.55228 2.41411e-08 8 0C7.44772 -2.41411e-08 7 0.447715 7 1L9 1ZM7.29289 34.7071C7.68342 35.0976 8.31658 35.0976 8.70711 34.7071L15.0711 28.3431C15.4616 27.9526 15.4616 27.3195 15.0711 26.9289C14.6805 26.5384 14.0474 26.5384 13.6569 26.9289L8 32.5858L2.34314 26.9289C1.95262 26.5384 1.31946 26.5384 0.928931 26.9289C0.538407 27.3195 0.538407 27.9526 0.928931 28.3431L7.29289 34.7071ZM7 1L7 34L9 34L9 1L7 1Z"
        fill="url(#paint0_linear_634_7130)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_634_7130"
          x1="7.62319"
          y1="6.55446"
          x2="-4.86813"
          y2="17.6033"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
